import { useEffect } from 'react';

const useAvoidBackgroundScrolling = (enabled: boolean) => {
  useEffect(() => {
    document.body.style.overflow = enabled ? 'hidden' : null;
    return () => {
      document.body.style.overflow = null;
    };
  }, [enabled]);
};

export default useAvoidBackgroundScrolling;
